var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 61.4405,0 A 61.4405,61.4405 0 1 0 122.881,61.4405 61.4405,61.4405 0 0 0 61.4405,0 Z m 6.14405,98.3048 H 55.29645 V 86.0167 h 12.2881 z m 0,-24.5762 H 55.29645 V 24.5762 h 12.2881 z","style":{"fill":"#ffc021","fillOpacity":"1","strokeWidth":"6.14405"}}));
}

Warning.defaultProps = {"enableBackground":"new 0 0 122.881 122.88","viewBox":"0 0 122.881 122.88","height":"122.88px","width":"122.881px","y":"0px","x":"0px","version":"1.1"};

module.exports = Warning;

Warning.default = Warning;
